import React, { useEffect, useState, useRef } from 'react';
import YouTube, { YouTubeProps } from 'react-youtube';
import cn from 'classnames';

import './twoPage1.scss';

function TwoPage1(props) {
  const { setCurrentPage, currentFooter } = props;
  

  const [isMob, setIsMob] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > 1024) {
        setIsMob(false);
      } else {
        setIsMob(true);
      }
      const resizeThrottler = () => {
        if (window.innerWidth < 1024) {
          setIsMob(true);
        } else {
          setIsMob(false);
        }
      };

      window.addEventListener('resize', resizeThrottler, false);
    }

    
  }, []);

  const [player1, setPlayer1] = useState();
  const [isPaused1, setIsPaused1] = useState(true);
  const [player2, setPlayer2] = useState();
  const [isPaused2, setIsPaused2] = useState(true);
  useEffect(() => {
   


  }, [player1]);

  const setPlay1 = (elem ) => {
    if (isPaused1) {
      player1.target.playVideo();
      setIsPaused1(false);
    } else {
      player1.target.pauseVideo();
      setIsPaused1(true);
    }

   

  }
  const setPlay2 = (elem ) => {
    if (isPaused2) {
      player2.target.playVideo();
      setIsPaused2(false);
    } else {
      player2.target.pauseVideo();
      setIsPaused2(true);
    }

   

  }

  let options;
  if (window.screen.width > 767) {
     options = {
      height: "409",
      width: "672",
      playerVars: {
        // autoplay: 1,
  
      },
    };
  } else {
     options = {
      height: "200",
      width: "335",
      playerVars: {
        // autoplay: 1,
  
      },
    };
  }



  return (
    <>
      <div className="growth-page growth-page--1">
        <div className="growth-page__row">
          <h1 className="growth-page__title _title _growth-anim">
            Сколько стоит ваш беспорядок <span>2.0</span>
          </h1>
        </div>
        <div className="growth-page__row growth-page__row--1">
          <div className="growth-page__time _growth-anim">
            <span className="growth-page__month">Январь</span>
            <span className="growth-page__year">2012</span>
          </div>
          <h2 className="growth-page__subtitle _large-text _growth-anim">
            Старт рекламной компании на&nbsp;федеральных ТВ-каналах с&nbsp;участием
            &laquo;Квартета&nbsp;И&raquo;
          </h2>
          <div className="growth-page__bg">
            <svg className="_gr-bg _gr-bg--1">
              <use href="/img/icons/icons.svg#_tl-bg-4"></use>
            </svg>
            <svg className="_gr-bg _gr-bg--2">
              <use href="/img/icons/icons.svg#_tl-bg-19"></use>
            </svg>
            <svg className="_gr-bg _gr-bg--3">
              <use href="/img/icons/icons.svg#_tl-bg-2"></use>
            </svg>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--2">
          <div className="growth-page__col">
            <div className="quote quote--white growth-page__quote _growth-anim">
              <div className="quote__content">
                <p className="quote__text _text">
                  Когда рекламный ролик &laquo;Авито&raquo; появился во&nbsp;время
                  &laquo;Титаника&raquo; на&nbsp;Первом канале, сайт не&nbsp;выдержал сильнейшего
                  наплыва пользователей и&nbsp;мы&nbsp;экстренно его восстанавливали
                </p>
              </div>
              <div className="quote__caption">
                <div className="quote__caption-img">
                  <img
                    src="/img/roman.png"
                    srcSet="/img/roman.png 1x, /img/roman@2x.png 2x"
                    alt="img"
                    className="img"
                  />
                </div>
                <span className="quote__caption-text">Роман Павлушко</span>
              </div>
            </div>
          </div>
          <div className="growth-page__col">
            <p className="growth-page__text _text _growth-anim">
              &laquo;Авито&raquo; первой среди российских интернет-компаний начинает массированную
              рекламную кампанию на&nbsp;федеральных телеканалах. Участники
              &laquo;Квартета&nbsp;И&raquo; теперь рекламируют продажу не&nbsp;только ненужных
              вещей, но&nbsp;и&nbsp;подержанных авто. А&nbsp;также&nbsp;&mdash; аренду квартир:
              их&nbsp;теперь можно снять прямо на&nbsp;&laquo;Авито&raquo;. Слоган &laquo;Сколько
              стоит ваш беспорядок?&raquo; становится культовым.
            </p>
            <p className="growth-page__text _text _growth-anim">
              В&nbsp;это время проникновение интернета в&nbsp;России приближается к&nbsp;50%,
              а&nbsp;обороты рунета растут ежегодно почти на&nbsp;треть.
            </p>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--3">
          <div className="growth-page__col"></div>
          <div className="growth-page__col">
            <div className="note growth-page__note _growth-anim">
              <p className="note__text _small-text">
                Сайт вошёл в&nbsp;топ-5 лидеров по&nbsp;посещаемости в&nbsp;Рунете, впереди были
                только &laquo;ВКонтакте&raquo;, &laquo;Одноклассники&raquo;, Mail.ru
                и&nbsp;&laquo;Яндекс&raquo;.
              </p>
            </div>
            <div className="note growth-page__note _growth-anim">
              <p className="note__text _small-text">
                Сервис запустил новые вертикали&nbsp;&mdash; &laquo;Авито Недвижимость&raquo;
                и&nbsp;&laquo;Авито Авто&raquo;
              </p>
            </div>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--4">
          <div className="growth-page__col">
            <div className="video growth-page__video _growth-anim">
              <div className="video__content">
                {/* <video src="#" poster="img/video-1.png"></video> */}
                <YouTube videoId={"rOqrmbBjftQ"}  opts={options}  onReady={(e)=>{setPlayer1(e)}}    />

                {/* <iframe width="560" height="315" src="https://www.youtube.com/embed/rOqrmbBjftQ?si=QIY1Dlpqgo6gNrpF" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> */}
              </div>
              <button className="video__btn" onClick={()=>setPlay1()}></button>
            </div>
          </div>
          <div className="growth-page__col">
            <div className="video growth-page__video _growth-anim">
              <div className="video__content">
                {/* <video src="#" poster="img/video-2.png"></video> */}
                <YouTube videoId={"qNBbtCIuRPo"}  opts={options}  onReady={(e)=>{setPlayer2(e)}}    />
              </div>
              <button className="video__btn" onClick={()=>setPlay2()}></button>
            </div>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--5">
          <div className="growth-page__time _growth-anim">
            <span className="growth-page__month">Декабрь</span>
            <span className="growth-page__year">2012</span>
          </div>
          <h2 className="growth-page__subtitle _large-text _growth-anim">
            У «Авито» новый дом — на Тверской, 22
          </h2>
          <div className="growth-page__wrap-img">
            <div className="growth-page__img _growth-anim">
              <img
                src="img/two/growth-page-1.png"
                srcSet="img/two/growth-page-1.png 1x, img/two/growth-page-1@2x.png 2x"
                alt="img"
                className="_growth-anim"
              />
            </div>
          </div>
          <div className="growth-page__bg">
            <svg className="_gr-bg _gr-bg--4">
              <use href="/img/icons/icons.svg#_tl-bg-8"></use>
            </svg>
            <svg className="_gr-bg _gr-bg--5">
              <use href="/img/icons/icons.svg#_tl-bg-2"></use>
            </svg>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--6">
          <div className="growth-page__col">
            {!isMob && (
              <div className="growth-page__wrap-img">
                <div className="growth-page__img _growth-anim">
                  <img
                    src="img/two/growth-page-2.png"
                    srcSet="img/two/growth-page-2.png 1x, img/two/growth-page-2@2x.png 2x"
                    alt="img"
                    className="_growth-anim"
                  />
                </div>
              </div>
            )}
            <div className="note growth-page__note _growth-anim">
              <p className="note__text _small-text">По итогам года выручка составила</p>
              <p className="note__main">$30 млн</p>
              <p className="note__text _small-text"> втрое больше, чем за предыдущий год.</p>
            </div>
          </div>
          <div className="growth-page__col">
            <h2 className="growth-page__subtitle _large-text _growth-anim">$75 млн</h2>
            <p className="growth-page__text _text _growth-anim">
              &laquo;Авито&raquo; привлекает от&nbsp;американской венчурной компании Accel Partners,
              фонда частных инвестиций Baring Vostok Capital Partners и&nbsp;прежних
              инвесторов&nbsp;&mdash; Investment AB Kinnevik и&nbsp;Northzone Ventures.
            </p>
            <p className="growth-page__text _text _growth-anim">
              &laquo;Авито&raquo;, как и&nbsp;планировалось, приносит первую прибыль.
            </p>
          </div>
          <div className="growth-page__bg">
            <svg className="_gr-bg _gr-bg--6">
              <use href="/img/icons/icons.svg#_tl-bg-3"></use>
            </svg>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--7">
          {isMob && (
            <div className="growth-page__wrap-img">
              <div className="growth-page__img _growth-anim">
                <img
                  src="img/two/growth-page-2.png"
                  srcSet="img/two/growth-page-2.png 1x, img/two/growth-page-2@2x.png 2x"
                  alt="img"
                  className="_growth-anim"
                />
              </div>
            </div>
          )}
          <div className="growth-page__wrap-img">
            <div className="growth-page__img _growth-anim">
              <img
                src="img/two/growth-page-3.png"
                srcSet="img/two/growth-page-3.png 1x, img/two/growth-page-3@2x.png 2x"
                alt="img"
                className="_growth-anim"
              />
            </div>
          </div>
          <div className="growth-page__bg">
            <svg className="_gr-bg _gr-bg--7">
              <use href="/img/icons/icons.svg#_tl-bg-6"></use>
            </svg>
          </div>
        </div>
        <div className="growth-page__footer _footer">
          <div className="growth-page__footer-col">
            <div className="growth-page__footer-date">
            2012
            </div>
          </div>
          <div
            className="growth-page__footer-col"
            onClick={() => setCurrentPage({ status: true, el: 2 })}>
            <div className="growth-page__footer-img">
              <img
                src={`img/two/growth-page-footer-2.png`}
                srcSet={`img/two/growth-page-footer-2
                }.png 1x, img/two/growth-page-footer-2@2x.png 2x`}
                alt="img"
              />
            </div>
            <span className="growth-page__footer-year">2013</span>
            <h3 className="growth-page__footer-title">
            Объединение Avito, Slando и OLX
            </h3>
          </div>
          <div className="growth-page__footer-col">
            <span
              className="growth-page__footer-date"
              onClick={() => setCurrentPage({ status: true, el: 2 })}>
              Далее
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default TwoPage1;
